module.exports = __webpack_public_path__ + "61372fcb11c29243cb9c962060a4d00c.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/plant-hat.png
 ** module id = 485
 ** module chunks = 0
 **/